import type { components } from "admination-react/api-schema";
import { sendJson } from "./http";

export type InviteCoachInput = {
  vorname: string;
  nachname: string;
  email: string;
  organisationId: string;
};

export function inviteCoach(input: InviteCoachInput): Promise<void> {
  const body: components["schemas"]["InviteCoachRequest"] = {
    vorname: input.vorname,
    nachname: input.nachname,
    email: input.email,
    organisation_id: input.organisationId,
  };
  return sendJson<void>("/team/invite-coach", "POST", body);
}

export function stammdatenComplete(coachingId: string): Promise<void> {
  return sendJson<void>("/team/stammdaten-complete", "POST", { coaching_id: coachingId });
}

export type SetMemberOwnerInput = { memberId: string; organisationId: string; isOwner: boolean };

export function setMemberOwner(input: SetMemberOwnerInput): Promise<components["schemas"]["MemberOwnerRead"]> {
  return sendJson<components["schemas"]["MemberOwnerRead"]>(`/team/members/${encodeURIComponent(input.memberId)}`, "PATCH", {
    organisation_id: input.organisationId,
    is_owner: input.isOwner,
  });
}
